<template>
  <div class="detailpage">
    <div class="depagetop">
      <div class="borderline">
        <div class="picstyle">
          <img :src="getDctImg(doctorInfo.GUID)" />
        </div>
        <p class="bigtitle">{{ doctorInfo.Name }}</p>
        <p class="pos">
          <span class="subject">{{ doctorInfo.Dpt_Name }}</span>
          <span class="subdoctor">{{ doctorInfo.Description }}</span>
        </p>
      </div>
      <div class="adept">
        <p>
          <span class="lineblue"></span>
          <span class="adepttit">擅长</span>
          <span class="flexspan" @click="exprand" v-show="!isshow">收起</span>
          <span class="flexspan" v-show="isshow" @click="exprand">展开</span>
        </p>
        <p class="fontclass" :class="{ clip: isshow }">{{ doctorInfo.Speciality }}</p>
      </div>
      <div class="adept mb20">
        <p>
          <span class="lineblue"></span>
          <span class="adepttit">简介</span>
          <span class="flexspan" @click="exprandt" v-show="!hasshow">收起</span>
          <span class="flexspan" v-show="hasshow" @click="exprandt">展开</span>
        </p>
        <p class="fontclass" :class="{ clip: hasshow }">{{ doctorInfo.Synopsis }}</p>
      </div>
    </div>

    <div class="detaildate swiper-container">
      <ul class="swiper-wrapper">
        <li
          v-for="(item, index) in doctorInfo.TimeDatas"
          :key="index"
          :class="['swiper-slide',ondate==item.StrData?'on':'']"
          @click="ondateClick(item.StrData)"
        >
          <span>{{item.StrWeek}}</span>
          <span>{{item.StrData}}</span>
        </li>
      </ul>
    </div>
    <div class="detailarr">
      <p class="arram"  v-for="(item, index) in doctorInfo.RegDcts" :key="index">
        <span>【{{item.StartTimeRange}}-{{item.EndTimeRange}}】</span>
        <span>
          余
          <span class="fontcolor">{{item.BespeakNumber}}</span>
        </span>
        <span>¥{{item.RegAmount}}</span>
        <span>
          <span :class="1 == 0 ? 'full' : 'appointment'" @click="surefun(item)">预约</span>
        </span>
      </p>
    </div>
  </div>
</template>
<script>
import {
  GetSchedulingByDctID,
  SetItem,
  UpdateSchedulingByDctID
} from "@/services/getData.js";
import weui from "weui.js";
import { debug } from "util";
import Swiper from "swiper";
import "swiper/swiper-bundle.min.css";
export default {
  name: "register-detail",
  data() {
    return {
      isshow: true,
      hasshow: true,
      doctorID: this.$route.params.doctorID,
      doctorInfo: {},
      ondate: ""
    };
  },
  created: function() {
    this.getSchedulingByDctID();
  },
  mounted() {},
  methods: {
    getDctImg(id) {
      if (id == undefined) {
        return;
      }
      console.log(id);
      return config.configURL + "GetDctImg?id=" + id;
    },
    exprand() {
      this.isshow = !this.isshow;
    },
    exprandt() {
      this.hasshow = !this.hasshow;
    },
    setHeight(num) {
      var h = num * 0.8 > 1.6 ? num * 0.8 : 1.6;
      return "height:" + h + "rem";
    },
    surefun(model) {
      if (model.BespeakNumber == 0) {
        return;
      }
      //储存选择医生对象
      SetItem("doctorInfo", JSON.stringify(this.doctorInfo));
      SetItem("doctorSelect", JSON.stringify(model));
      //跳转到确定挂号页
      this.$router.push({ path: "/register/registersure" });
    },
    getSchedulingByDctID() {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });
      GetSchedulingByDctID(this.doctorID,"").then(response => {
        if (response.data) {
          console.info(response.data);
          loading.hide();
          this.doctorInfo = response.data;
          var firstDate = response.data.TimeDatas;
          if(firstDate.length > 0)
          {
              this.ondate = firstDate[0].StrData;
          }
          
          this.$nextTick(() => {
            var swiper = new Swiper(".swiper-container", {
              slidesPerView: 5,
              spaceBetween: 10
            });
            this.$once('hook:beforeDestory',() => {
              swiper.destory();
            });
          });
        } else {
          alert(response.data.Content);
        }
      });
    },
    UpdateSchedulingByDctID(time) {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });
      GetSchedulingByDctID(this.doctorID, time).then(response => {
        if (response.data) {
          loading.hide();
          this.doctorInfo.RegDcts = response.data.RegDcts;
        } else {
          alert(response.data.Content);
        }
      });
    },
    ondateClick(date) {
      this.ondate = date;
      this.UpdateSchedulingByDctID(this.ondate);
    }
  }
};
</script>
<style>
.detailpage {
  width: 100%;
  height: 100%;
  overflow: auto;
}

.detailpage .depagetop {
  box-sizing: border-box;
  background-color: white;
}

.detailpage .depagetop .borderline {
  position: relative;
  border-bottom: 0.01rem solid rgba(242, 242, 242, 1);
  background-image: url("../../assets/images/regbg.png");
  height: 2.75rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  box-sizing: border-box;
  padding-top: 0.35rem;
}

.detailpage .depagetop .picstyle {
  text-align: center;
}

.detailpage .depagetop .picstyle > img {
  width: 0.75rem;
  height: 0.75rem;
  margin: 0 auto;
}

.detailpage .depagetop .borderline .pos {
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
}

.detailpage .depagetop .bigtitle {
  font-size: 0.36rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 0.8rem;
  text-align: center;
  margin-bottom: 0.15rem;
}

.detailpage .depagetop .subject {
  font-size: 0.18rem;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 0.3rem;
  padding: 0 0.12rem;
  height: 0.3rem;
  background: rgba(87, 156, 83, 1);
  border-radius: 0.1rem;
  margin-right: 0.16rem;
  display: inline-block;
  text-align: center;
}

.detailpage .depagetop .subdoctor {
  display: inline-block;
  font-size: 0.18rem;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 0.3rem;
  padding: 0 0.12rem;
  height: 0.3rem;
  background: rgba(61, 151, 209, 1);
  border-radius: 0.1rem;
  text-align: center;
}

.depagetop .adept {
  box-sizing: border-box;
  padding: 0.16rem 0.2rem;
  border-bottom: 0.01rem solid rgba(242, 242, 242, 1);
}

.depagetop .adept .lineblue {
  display: inline-block;
  width: 0.11rem;
  height: 0.3rem;
  background: rgba(61, 151, 209, 1);
  border-radius: 0.06rem;
  margin-right: 0.1rem;
}

.depagetop .adept .adepttit {
  display: inline-block;
  font-size: 0.26rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.depagetop .adept .flexspan {
  display: block;
  float: right;
  font-size: 0.22rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(61, 151, 209, 1);
}

.depagetop .adept .fontclass {
  font-size: 0.22rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 0.36rem;
}

.depagetop .adept .clip {
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
}

.detaildate {
  width: 100%;
  height: 0.8rem;
  background: #ffffff;
  margin: 0.2rem 0;
}
/* .detaildate ul {
  display: flex;
} */
.detaildate ul li {
  /* flex: 1; */
  padding: 0.1rem 0;
  box-sizing: border-box;
  color: rgba(61, 151, 209, 1);
  text-align: center;
}
.detaildate ul li span {
  /* width: 100%; */
  height: 0.3rem;
  line-height: 0.3rem;
  /* text-align: center; */
  display: block;
  font-family: MicrosoftYaHei;
  font-weight: 400;
}
.detaildate ul li.on {
  background: rgba(61, 151, 209, 1);
  color: #ffffff;
}
.detailarr {
  width: 100%;
  font-size: 0.26rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 0.36rem;
  box-sizing: border-box;
  background-color: #ffffff;
}
.detailarr .arram {
  height: 0.8rem;
  box-sizing: border-box;
  padding: 0.2rem 0rem;
  border-bottom: 0.01rem solid rgba(221, 221, 221, 1);
  padding-left: 0.21rem;
  flex-direction: row;
  display: flex;
}

.detailarr .arram:last-child {
  border: 0;
}

.detailarr .arram > span {
  flex: 1;
}
.detailarr .arram > span:first-child {
  flex: none;
  width: 2.2rem;
}
.detailarr .arram > span:last-child {
  flex: none;
  width: 1.2rem;
}
.detailarr .arram .fontcolor {
  color: #fda62b !important;
}

.detailarr .arram .full {
  width: 1rem;
  height: 0.4rem;
  background: rgba(187, 187, 187, 1);
  border-radius: 0.2rem;
  display: inline-block;
  text-align: center;
  color: white !important;
}

.detailarr .arram .appointment {
  width: 1rem;
  height: 0.4rem;
  line-height: 0.4rem;
  background: rgba(61, 151, 209, 1);
  border-radius: 0.2rem;
  display: inline-block;
  text-align: center;
  color: white !important;
}

/* .detailpagecon .arrange {
  margin-bottom: 0.1rem;
  height: 1.6rem;
}

.detailpagecon .arrange .arrleft {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  width: 25%;
  text-align: center;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 0.36rem;
  background-color: #3d97d1;
  font-size: 0.26rem;
  height: 100%;
  box-sizing: border-box;
  padding: 0.45rem 0;
}
.detailpagecon .arrange .arrright {
  display: block;
  float: right;
  width: 75%;
  font-size: 0.26rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 0.36rem;
  box-sizing: border-box;
  background-color: white;
  height: 100%;
}

.detailpagecon .arrange .arrrightam {
  height: 0.8rem;
  box-sizing: border-box;
  padding: 0.2rem 0rem;
  border-bottom: 0.01rem solid rgba(221, 221, 221, 1);
  padding-left: 0.21rem;
  flex-direction: row;
  display: flex;
}

.detailpagecon .arrange .arrrightam:last-child {
  border: 0;
}

.detailpagecon .arrange .arrrightam > span {
  flex: 1;
}
.detailpagecon .arrange .arrrightam > span:first-child {
  flex: none;
  width: 1.6rem;
}
.detailpagecon .arrange .arrrightam > span:last-child {
  flex: none;
  width: 1.2rem;
}
.detailpagecon .arrange .arrrightpm {
  padding-top: 0.23rem;
  padding-left: 0.21rem;
  flex-direction: row;
  display: flex;
}

.detailpagecon .arrange .arrrightpm > span {
  flex: 1;
}

.detailpage .mb20 {
  margin-bottom: 0.2rem;
}

.detailpagecon .arrange .fontcolor {
  color: #fda62b !important;
}

.detailpagecon .arrange .full {
  width: 1rem;
  height: 0.4rem;
  background: rgba(187, 187, 187, 1);
  border-radius: 0.2rem;
  display: inline-block;
  text-align: center;
  color: white !important;
}

.detailpagecon .arrange .appointment {
  width: 1rem;
  height: 0.4rem;
  line-height: 0.4rem;
  background: rgba(61, 151, 209, 1);
  border-radius: 0.2rem;
  display: inline-block;
  text-align: center;
  color: white !important;
}

.detailpagecon {
  height: auto;
  width: 100%;
} */
</style>



// WEBPACK FOOTER //
// src/components/register/register-detail.vue